const NotFoundPage = () => {

    return(
        <h1>Pagina no encontrada</h1>
    )
}

export default NotFoundPage;